<template>
  <section class="aboutus-section aboutus-culture-section">
    <h2 class="aboutus-title">{{ t('aboutUs.culture.title') }}</h2>
    <div class="aboutus-title-underline"></div>
    <div class="aboutus-culture-row">
      <div class="aboutus-culture-item">
        <img src="../../assets/aboutUs/culture01.png" :alt="t('aboutUs.culture.visionAlt')" />
        <div class="aboutus-culture-label">{{ t('aboutUs.culture.vision') }}</div>
        <div class="aboutus-culture-desc" v-html="t('aboutUs.culture.visionDesc')"></div>
      </div>
      <div class="aboutus-culture-item">
        <img src="../../assets/aboutUs/culture02.png" :alt="t('aboutUs.culture.missionAlt')" />
        <div class="aboutus-culture-label">{{ t('aboutUs.culture.mission') }}</div>
        <div class="aboutus-culture-desc" v-html="t('aboutUs.culture.missionDesc')"></div>
      </div>
      <div class="aboutus-culture-item">
        <img src="../../assets/aboutUs/culture03.png" :alt="t('aboutUs.culture.coreValuesAlt')" />
        <div class="aboutus-culture-label">{{ t('aboutUs.culture.coreValues') }}</div>
        <div class="aboutus-culture-desc" v-html="t('aboutUs.culture.coreValuesDesc')"></div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>
<style scoped>
.aboutus-section {
  width: 80%;
  margin: 0 auto;
  padding: 56px 0 0 0;
  background: #fff;
  margin-bottom: 100px;
}

.aboutus-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 8px;
  position: relative;
}

.aboutus-title-underline {
  width: 80px;
  height: 4px;
  background: #ff7f1a;
  margin: 10px auto 40px auto;
}

.aboutus-culture-section {
  background: #fff;
  padding: 56px 0 0 0;
}

.aboutus-culture-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  margin-top: 80px;
}

.aboutus-culture-item {
  flex: 1;
  text-align: center;
}

.aboutus-culture-item img {
  width: 8vw;
  margin-bottom: 16px;
}

.aboutus-culture-label {
  font-size: 1.1rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 20px;
  margin-top: 4vh;
}

.aboutus-culture-desc {
  /* 需要适配 */
  font-size: 1rem;
  line-height: 2;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .aboutus-section {
    width: 80%;
  }

  .aboutus-title {
    font-size: 2.4rem;
  }

  .aboutus-title-underline {
    width: 80px;
    height: 4px;
  }

  .aboutus-culture-item img {
    width: 8vw;
    margin-bottom: 16px;
  }

  .aboutus-culture-label {
    /* 需要适配 */
    font-size: 1.5rem;
  }

  .aboutus-culture-desc {
    /* 需要适配 */
    font-size: 1.2rem;
    line-height: 2;
  }

  .aboutus-title-underline {
    width: 80px;
  }

  .aboutus-culture-row {
    margin-top: 80px;
  }

  .aboutus-culture-section {
    padding: 56px 0 0 0;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .aboutus-section {
    width: 85%;
  }

  .aboutus-title {
    font-size: 2.2rem;
  }

  .aboutus-title-underline {
    width: 80px;
    height: 4px;
  }

  .aboutus-culture-item img {
    width: 10vw;
    margin-bottom: 14px;
  }

  .aboutus-culture-label {
    /* 需要适配 */
    font-size: 1.3rem;
  }

  .aboutus-culture-desc {
    /* 需要适配 */
    font-size: 1rem;
    line-height: 1.8;
  }

  .aboutus-title-underline {
    width: 70px;
  }

  .aboutus-culture-row {
    margin-top: 70px;
  }

  .aboutus-culture-section {
    padding: 46px 0 0 0;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .aboutus-section {
    width: 90%;
  }

  .aboutus-title {
    font-size: 2rem;
  }

  .aboutus-title-underline {
    width: 80px;
    height: 4px;
  }

  .aboutus-culture-item img {
    width: 12vw;
    margin-bottom: 12px;
  }

  .aboutus-culture-label {
    /* 需要适配 */
    font-size: 1.1rem;
  }

  .aboutus-culture-desc {
    /* 需要适配 */
    font-size: 0.9rem;
    line-height: 1.7;
  }

  .aboutus-title-underline {
    width: 60px;
  }

  .aboutus-culture-row {
    margin-top: 60px;
  }

  .aboutus-culture-section {
    padding: 36px 0 0 0;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .aboutus-section {
    width: 95%;
  }

  .aboutus-title {
    font-size: 1.8rem;
  }

  .aboutus-title-underline {
    width: 70px;
    height: 4px;
  }

  .aboutus-culture-item img {
    width: 14vw;
    margin-bottom: 10px;
  }

  .aboutus-culture-label {
    /* 需要适配 */
    font-size: 1rem;
  }

  .aboutus-culture-desc {
    /* 需要适配 */
    font-size: 0.8rem;
    line-height: 1.7;
  }

  .aboutus-title-underline {
    width: 50px;
  }

  .aboutus-culture-row {
    margin-top: 50px;
  }

  .aboutus-culture-section {
    padding: 26px 0 0 0;
  }
}
</style>